/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getArrayDecoder,
  getArrayEncoder,
  getBooleanDecoder,
  getBooleanEncoder,
  getOptionDecoder,
  getOptionEncoder,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  some,
  transformEncoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
  type Option,
  type OptionOrNullable,
} from '@solana/kit';
import {
  getCreatorDecoder,
  getCreatorEncoder,
  getTokenStandardDecoder,
  getTokenStandardEncoder,
  TokenStandard,
  type Creator,
  type CreatorArgs,
  type TokenStandardArgs,
} from '.';

export type MetadataArgsV2 = {
  /** The name of the asset */
  name: string;
  /** The symbol for the asset */
  symbol: string;
  /** URI pointing to JSON representing the asset */
  uri: string;
  /** Royalty basis points that goes to creators in secondary sales (0-10000) */
  sellerFeeBasisPoints: number;
  /** Immutable, once flipped, all sales of this metadata are considered secondary. */
  primarySaleHappened: boolean;
  /** Whether or not the data struct is mutable, default is not */
  isMutable: boolean;
  /** Token standard.  Currently only `NonFungible` is allowed. */
  tokenStandard: Option<TokenStandard>;
  /** Creator array */
  creators: Array<Creator>;
  /** Collection.  Note in V2 its just a `Pubkey` and is always considered verified. */
  collection: Option<Address>;
};

export type MetadataArgsV2Args = {
  /** The name of the asset */
  name: string;
  /** The symbol for the asset */
  symbol?: string;
  /** URI pointing to JSON representing the asset */
  uri: string;
  /** Royalty basis points that goes to creators in secondary sales (0-10000) */
  sellerFeeBasisPoints: number;
  /** Immutable, once flipped, all sales of this metadata are considered secondary. */
  primarySaleHappened?: boolean;
  /** Whether or not the data struct is mutable, default is not */
  isMutable?: boolean;
  /** Token standard.  Currently only `NonFungible` is allowed. */
  tokenStandard?: OptionOrNullable<TokenStandardArgs>;
  /** Creator array */
  creators: Array<CreatorArgs>;
  /** Collection.  Note in V2 its just a `Pubkey` and is always considered verified. */
  collection: OptionOrNullable<Address>;
};

export function getMetadataArgsV2Encoder(): Encoder<MetadataArgsV2Args> {
  return transformEncoder(
    getStructEncoder([
      ['name', addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
      ['symbol', addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
      ['uri', addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
      ['sellerFeeBasisPoints', getU16Encoder()],
      ['primarySaleHappened', getBooleanEncoder()],
      ['isMutable', getBooleanEncoder()],
      ['tokenStandard', getOptionEncoder(getTokenStandardEncoder())],
      ['creators', getArrayEncoder(getCreatorEncoder())],
      ['collection', getOptionEncoder(getAddressEncoder())],
    ]),
    (value) => ({
      ...value,
      symbol: value.symbol ?? '',
      primarySaleHappened: value.primarySaleHappened ?? false,
      isMutable: value.isMutable ?? true,
      tokenStandard: value.tokenStandard ?? some(TokenStandard.NonFungible),
    })
  );
}

export function getMetadataArgsV2Decoder(): Decoder<MetadataArgsV2> {
  return getStructDecoder([
    ['name', addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ['symbol', addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ['uri', addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ['sellerFeeBasisPoints', getU16Decoder()],
    ['primarySaleHappened', getBooleanDecoder()],
    ['isMutable', getBooleanDecoder()],
    ['tokenStandard', getOptionDecoder(getTokenStandardDecoder())],
    ['creators', getArrayDecoder(getCreatorDecoder())],
    ['collection', getOptionDecoder(getAddressDecoder())],
  ]);
}

export function getMetadataArgsV2Codec(): Codec<
  MetadataArgsV2Args,
  MetadataArgsV2
> {
  return combineCodec(getMetadataArgsV2Encoder(), getMetadataArgsV2Decoder());
}
